import { AreaResource, AreaType } from '../../area.resource';

export class AreaCalibrationsResource extends AreaResource {
  public static readonly TYPE = AreaType.calibrations;

  id: any;
  links: any;

  commesse: any[] = [];
  site: string = '';
  profile: any;
  type_user: any;
  notes: string = '';
  sub_system: any;

  phone:string = null;
  company:string = null;
  stamp_code:string = null;
  function:string = null;

  constructor() {
    super(AreaCalibrationsResource.TYPE);
  }
}


export class OrderResource {
  segment_code: string;
  project_name: string;
  project_description: string;
  active: boolean;
  cdc_type: string;
}


export class CommonAreaCalibrationFieldResource{
  description: string;
  id: number;
  links: any[];
  value: string;
}

export class SubSystemResource extends CommonAreaCalibrationFieldResource{}
export class TypeUserResource extends CommonAreaCalibrationFieldResource{}
export class ProfileResource extends CommonAreaCalibrationFieldResource{}